import {
    ContextActionType,
    LazyBreadcrumb,
    useDumbActionsContext,
} from '@europrocurement/flexy-components';
import {
    CollectionOpenSearch,
    CollectionOpenSearchSelector,
    ORDERS_OPEN_SEARCH_SLICE_NAME,
    useFormaliteService,
    useSociete,
} from '@europrocurement/l2d-domain';
import {
    OrderActionContext,
    ordersBasePath,
    OrderTable,
    useDefaultContextActions,
} from '@europrocurement/l2d-modules';
import { DataSource } from '@europrocurement/l2d-redux-utils';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import React, { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { AnyAction } from '@reduxjs/toolkit';
import { useOrderTable } from '../../hooks';

const ListeOrders: React.FunctionComponent = function () {
    const navigate = useNavigate();
    const datasource: DataSource<CollectionOpenSearch> = useSelector(CollectionOpenSearchSelector);
    const dispatch = useDispatch();
    const { columns, filters, preFilters, rowActions } = useOrderTable();
    const [filtersInitialized, setFiltersInitialized] = useState<boolean>(false);
    const xIdSociete = useSociete();
    const { getOpenSearchCollections } = useFormaliteService();
    const { updatingOrder } = useContext(OrderActionContext);
    const breadcrumbItems = [
        {
            link: '/accueil',
            icon: {
                icon: ['fasl', 'house'] as IconProp,
                sx: { display: 'flex', alignItems: 'center' },
            },
        },
        {
            link: '/collections',
            path: 'Formalités',
        },
        'Liste des commandes',
    ];
    const { backContextActions } = useDefaultContextActions();

    useEffect(() => {
        dispatch({
            type: `${ORDERS_OPEN_SEARCH_SLICE_NAME}/setmainPagination`,
            payload: {
                page: 1,
                itemsPerPage: 10,
            },
        });
        dispatch({
            type: `${ORDERS_OPEN_SEARCH_SLICE_NAME}/setmainFilter`,
            payload: {
                key: 'societeId',
                value: [xIdSociete],
            },
        });
        dispatch(getOpenSearchCollections({}) as unknown as AnyAction);
        setFiltersInitialized(true);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [xIdSociete, updatingOrder]);

    const handleRowClick = ({ id }: CollectionOpenSearch) => {
        navigate(`/${ordersBasePath}/${id}`);
    };

    const contextActions: ContextActionType[] = [...backContextActions];

    useDumbActionsContext(contextActions);

    if (!filtersInitialized) {
        return null;
    }
    return (
        <>
            <LazyBreadcrumb
                path={breadcrumbItems}
                separator=" / "
                sx={{ marginBottom: '1.5em' }}
            />

            <OrderTable
                datasource={datasource}
                columns={columns}
                filters={filters}
                preFilters={preFilters}
                rowActions={rowActions}
                onRowClick={handleRowClick}
            />
        </>
    );
};

export default ListeOrders;
